"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getModifiersIndexes = exports.getProductOptionsWithoutModifiers = exports.getProductOptionsSelectionIdsWithoutModifiers = exports.findProductItemBySelectionIds = exports.getOptionBySelectionId = exports.variantsCount = exports.actualSku = exports.hasSurcharge = exports.formattedSecondaryPrice = exports.formattedPrimaryPrice = exports.hasAnyDiscount = exports.hasDiscount = exports.hasAutomaticDiscount = exports.actualPrice = exports.isSubscribeNow = exports.isSelectedSubscriptionOneTimePurchase = exports.hasSubscriptionPlans = exports.hasVariantInStock = exports.formatCustomTextFields = exports.validateUserInputs = exports.userInputsFactory = exports.isPreOrder = exports.inStock = exports.selectProductOptionItemsByType = exports.selectProductOptionItems = exports.first = exports.last = void 0;
var lodash_1 = require("lodash");
var quantityCalculator_1 = require("../quantity-calculator/quantityCalculator");
var product_1 = require("../types/product");
function last(array) {
    return array[array.length - 1];
}
exports.last = last;
function first(array) {
    return array[0];
}
exports.first = first;
function selectProductOptionItems(product) {
    return product.options;
}
exports.selectProductOptionItems = selectProductOptionItems;
function selectProductOptionItemsByType(product, type) {
    return product.options.find(function (o) { return o.optionType === type; });
}
exports.selectProductOptionItemsByType = selectProductOptionItemsByType;
function inStock(product, variant) {
    var ref = variant || product;
    if (product.isInStock === false) {
        return false;
    }
    if (!variant && product.isInStock !== undefined) {
        return product.isInStock;
    }
    if (product.isTrackingInventory) {
        if (variant) {
            return ref.inventory.quantity > 0;
        }
        return product.inventory.quantity > 0 || product.productItems.some(function (item) { return item.inventory.quantity > 0; });
    }
    return ref.inventory.status === product_1.ProductInventoryStatus.IN_STOCK;
}
exports.inStock = inStock;
function isPreOrder(product, variant) {
    if (!product && !variant) {
        return false;
    }
    if (variant) {
        return variant.availableForPreOrder;
    }
    if (product.isManageProductItems) {
        var isAllVariantsPreOrder = product.productItemsPreOrderAvailability === product_1.IProductPreOrderAvailability.ALL_VARIANTS;
        var isSomeVariantsPreOrder = product.productItemsPreOrderAvailability === product_1.IProductPreOrderAvailability.SOME_VARIANTS;
        return isAllVariantsPreOrder || (isSomeVariantsPreOrder && !product.isInStock);
    }
    return product.inventory.availableForPreOrder;
}
exports.isPreOrder = isPreOrder;
function userInputsFactory() {
    return { selection: [], text: [], quantity: [], subscriptionPlan: [] };
}
exports.userInputsFactory = userInputsFactory;
function validateUserInputs(product, userInputs, isValidateInventory) {
    if (isValidateInventory === void 0) { isValidateInventory = true; }
    var errors = userInputsFactory();
    var quantityRange = quantityCalculator_1.QuantityCalculator.getQuantitiesRange(product, userInputs.selection);
    var userQuantity = Number(userInputs.quantity[0]);
    product.options.forEach(function (_, i) {
        errors.selection[i] = !userInputs.selection[i];
    });
    if (product.customTextFields) {
        product.customTextFields.forEach(function (item, i) {
            errors.text[i] = item.isMandatory === true && !userInputs.text[i];
        });
    }
    errors.quantity = [
        isValidateInventory
            ? (isNaN(userQuantity) || userQuantity < first(quantityRange) || userQuantity > last(quantityRange)) === true
            : false,
    ];
    var isProductSubscription = !!(0, lodash_1.get)(product.subscriptionPlans, ['list', '0']);
    var isSelectedPlan = !!(0, lodash_1.get)(userInputs.subscriptionPlan, ['0']);
    errors.subscriptionPlan = [isProductSubscription && !isSelectedPlan];
    return errors;
}
exports.validateUserInputs = validateUserInputs;
function formatCustomTextFields(product, userInputs) {
    var customTextFields = [];
    return (product.customTextFields || []).reduce(function (acc, field, i) {
        acc.push({
            customText: { title: field.title, key: field.key, isMandatory: field.isMandatory },
            answer: userInputs.text[i] || '',
        });
        return acc;
    }, customTextFields);
}
exports.formatCustomTextFields = formatCustomTextFields;
function hasVariantInStock(product) {
    return product.productItems.some(function (option) { return inStock(product, option); });
}
exports.hasVariantInStock = hasVariantInStock;
function hasSubscriptionPlans(product) {
    var _a;
    return ((_a = product.subscriptionPlans) === null || _a === void 0 ? void 0 : _a.list.filter(function (subPlan) { return subPlan.visible === true; }).length) > 0;
}
exports.hasSubscriptionPlans = hasSubscriptionPlans;
function isSelectedSubscriptionOneTimePurchase(selectedSubscriptionPlanId) {
    return selectedSubscriptionPlanId === 'one-time-purchase';
}
exports.isSelectedSubscriptionOneTimePurchase = isSelectedSubscriptionOneTimePurchase;
function isSubscribeNow(product, selectedSubscriptionPlanId) {
    return !isSelectedSubscriptionOneTimePurchase(selectedSubscriptionPlanId) && hasSubscriptionPlans(product);
}
exports.isSubscribeNow = isSubscribeNow;
function actualPrice(product, variant) {
    var isDiscounted = hasDiscount(product);
    var isSurcharged = hasSurcharge(variant);
    var ref = variant || product;
    if (isSurcharged) {
        return isDiscounted ? variant.comparePrice : variant.price;
    }
    return isDiscounted ? ref.comparePrice : ref.price;
}
exports.actualPrice = actualPrice;
function hasAutomaticDiscount(product) {
    var _a;
    return Boolean((_a = product.itemDiscount) === null || _a === void 0 ? void 0 : _a.priceAfterDiscount);
}
exports.hasAutomaticDiscount = hasAutomaticDiscount;
function hasDiscount(product) {
    var _a;
    return ((_a = product.discount) === null || _a === void 0 ? void 0 : _a.value) > 0;
}
exports.hasDiscount = hasDiscount;
function hasManualDiscount(product, variant) {
    var _a, _b;
    if (variant) {
        return (_a = variant.hasDiscount) !== null && _a !== void 0 ? _a : (Boolean(variant.formattedComparePrice) && variant.comparePrice > 0);
    }
    else {
        return ((_b = product.discount) === null || _b === void 0 ? void 0 : _b.value) > 0 && Boolean(product.formattedComparePrice);
    }
}
function hasAnyDiscount(product, variant) {
    return hasManualDiscount(product, variant) || hasAutomaticDiscount(product);
}
exports.hasAnyDiscount = hasAnyDiscount;
function formattedPrimaryPrice(product, variant) {
    var isAutomaticDiscountExist = hasAutomaticDiscount(product);
    var isManualDiscountExist = hasManualDiscount(product, variant);
    if (isAutomaticDiscountExist) {
        return product.itemDiscount.priceAfterDiscount;
    }
    else if (isManualDiscountExist) {
        return variant ? variant.formattedComparePrice : product.formattedComparePrice;
    }
    return product.formattedPrice;
}
exports.formattedPrimaryPrice = formattedPrimaryPrice;
function formattedSecondaryPrice(product, variant) {
    var isAutomaticDiscountExist = hasAutomaticDiscount(product);
    var isManualDiscountExist = hasManualDiscount(product, variant);
    if (isAutomaticDiscountExist && isManualDiscountExist) {
        return product.formattedComparePrice;
    }
    else if (isManualDiscountExist || isAutomaticDiscountExist) {
        if (isManualDiscountExist) {
            return variant ? variant.formattedPrice : product.formattedPrice;
        }
        return product.formattedPrice;
    }
    return undefined;
}
exports.formattedSecondaryPrice = formattedSecondaryPrice;
function hasSurcharge(variant) {
    return (variant === null || variant === void 0 ? void 0 : variant.surcharge) < 0;
}
exports.hasSurcharge = hasSurcharge;
function actualSku(product, variant) {
    return (variant === null || variant === void 0 ? void 0 : variant.sku) || product.sku;
}
exports.actualSku = actualSku;
function variantsCount(product, _a) {
    var _b, _c, _d, _e;
    var _f = _a === void 0 ? {} : _a, _g = _f.includeModifiers, includeModifiers = _g === void 0 ? true : _g;
    if (includeModifiers) {
        if (((_b = product.productItemsSummary) === null || _b === void 0 ? void 0 : _b.productItemsCount) > 0) {
            return product.productItemsSummary.productItemsCount;
        }
        else if (((_c = product.options) === null || _c === void 0 ? void 0 : _c.length) > 0) {
            return product.options.map(function (o) { return o.selections.length; }).reduce(function (prev, current) { return prev * current; }, 1);
        }
        return 0;
    }
    else {
        return (_e = (_d = product.productItemsSummary) === null || _d === void 0 ? void 0 : _d.productItemsCount) !== null && _e !== void 0 ? _e : 0;
    }
}
exports.variantsCount = variantsCount;
function getOptionBySelectionId(_a) {
    var product = _a.product, selectionId = _a.selectionId;
    return product.options.find(function (option) { return option.selections.some(function (selection) { return selection.id === selectionId; }); });
}
exports.getOptionBySelectionId = getOptionBySelectionId;
function findProductItemBySelectionIds(_a) {
    var product = _a.product, selectionIds = _a.selectionIds;
    return product.productItems.find(function (productItem) {
        return productItem.optionsSelections.every(function (selectionIdInItem) { return selectionIds.includes(selectionIdInItem); });
    });
}
exports.findProductItemBySelectionIds = findProductItemBySelectionIds;
function getProductOptionsSelectionIdsWithoutModifiers(product) {
    return getProductOptionsWithoutModifiers(product)
        .map(function (option) { return option.selections.map(function (selection) { return selection.id; }); })
        .flat();
}
exports.getProductOptionsSelectionIdsWithoutModifiers = getProductOptionsSelectionIdsWithoutModifiers;
function getProductOptionsWithoutModifiers(product) {
    var _a, _b, _c;
    var aVariantOptionsSelection = (_b = (_a = product.productItems) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.optionsSelections;
    return (_c = product.options) === null || _c === void 0 ? void 0 : _c.filter(function (option) {
        var _a;
        return (0, lodash_1.intersection)((_a = option.selections) === null || _a === void 0 ? void 0 : _a.map(function (selection) { return selection.id; }), aVariantOptionsSelection).length > 0;
    });
}
exports.getProductOptionsWithoutModifiers = getProductOptionsWithoutModifiers;
function getModifiersIndexes(product) {
    var _a, _b, _c;
    var aVariantOptionsSelection = (_b = (_a = product.productItems) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.optionsSelections;
    var modifierIndexes = [];
    (_c = product.options) === null || _c === void 0 ? void 0 : _c.forEach(function (option, index) {
        var _a;
        if ((0, lodash_1.intersection)((_a = option.selections) === null || _a === void 0 ? void 0 : _a.map(function (selection) { return selection.id; }), aVariantOptionsSelection).length === 0) {
            modifierIndexes.push(index);
        }
    });
    return modifierIndexes;
}
exports.getModifiersIndexes = getModifiersIndexes;
//# sourceMappingURL=productUtils.js.map